// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h3 id="january-13-2020">January 13, 2020</h3>
      <p>Launched Veteran Confirmation API with a status endpoint</p>
      <ul>
      <li><code>/status</code>: Allows third-parties to request confirmation from the VA of an individual's Veteran status after providing a valid API key and identifying attributes for the individual.</li>
      </ul>
      <p><a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3676">View code change(s)</a></p>
    </div>
  );
};

export default MarkdownComponent;
